/**
 * Shared top-level navigation menu.
 * Used by AppBar (desktop tabs) and BottomNav (mobile bottom bar).
 * Keep the order/titles in sync with the routes in src/router.js.
 */
export default [
  {
    title: "Map",
    icon: "mdi-map",
    to: "/account/dashboard",
  },
  {
    icon: "mdi-car",
    title: "Asset Info",
    to: "/account/asset_info",
  },
  {
    icon: "mdi-map-marker-path",
    title: "Trips",
    to: "/account/trips",
  },
  {
    icon: "mdi-bell",
    title: "Alerts",
    to: "/account/alerts",
  },
  {
    icon: "mdi-history",
    title: "Playback",
    to: "/account/playback",
  },
  {
    title: "Reports",
    icon: "mdi-file-multiple-outline",
    to: "/account/reports",
  },
];
